@if (useDefaultWidgetCaptcha()) {
  <div>
    <cap-widget
      data-cap-i18n-error-label="Oops! Hop back and prove you’re not a bot."
      data-cap-i18n-initial-state="Click to prove you're a Bunny!"
      data-cap-i18n-solved-label="Hooray! You're a real Bunny! 🥳"
      data-cap-i18n-verifying-label="Hang tight! We're checking if you're a Bunny..."
      data-e2e="defaultCaptcha"
      id="captcha-widget"
      [attr.data-cap-api-endpoint]="challengeUrl" />
  </div>
} @else {
  <!-- @let percent = progressPercent | number: '1.0-0'; -->
  <!-- CUSTOM CAPTCHA -->
  @if (!errorOnlyCaptcha()) {
    <bn-web-ui-alert
      class="text-start mb-4"
      data-e2e="visibleCaptcha"
      [alertType]="progressPercent() < 100 ? 'info' : 'success'"
      [showIcon]="progressPercent() === 100">
      @if (progressPercent() !== 100) {
        <bn-web-ui-loading
          size="xs"
          [isInline]="true"
          [isTransparent]="true"
          [showSpinner]="true" />
        <span class="ms-2">Hang tight! We're checking if you're a Bunny...</span>
      }
      @if (progressPercent() === 100 && !isRobot()) {
        Hooray! You're a real Bunny! 🥳
      }
      @if (progressPercent() === 100 && isRobot()) {
        Oops! Hop back and prove you’re not a bot.
      }
    </bn-web-ui-alert>
  }
  <!-- SHOW ONLY IF IT FAILS, OTHER STUFF IS HIDDEN -->
  @if (errorOnlyCaptcha() && (isError() || isRobot())) {
    <bn-web-ui-alert
      alertType="danger"
      class="text-start mb-4"
      data-e2e="invisibleCaptchaError"
      [showIcon]="true">
      <!-- Display other errors only, skip not robot 'Invalid solution' -->
      @if (!!isError() && !isRobot()) {
        <ng-continer>Something went wrong. Please try again or <a href="mailto:support@bunny.net">contact support.</a> </ng-continer>
      }
      @if (isRobot()) {
        <ng-continer> It looks like you’re not human. If this is a mistake, please <a href="mailto:support@bunny.net">let us know .</a></ng-continer>
      }
    </bn-web-ui-alert>
  }
}
